import { Outlet } from "react-router-dom"
import Navigation from "../components/Navigation"
import "./css/AccountingExternal.css"

const AccountingExternal = () => {
    return (
        <div className="_1pjm">
            <div>
                <Navigation />
            </div> 
            <div>
                <Outlet />
            </div>
        </div>
    )
}

export default AccountingExternal
